module.exports = __webpack_public_path__ + "img/light.9bbf152a.svg";